import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import Axios, { authHeaders } from '../../utils/axios';

// Async Thunk to fetch dropdown data for properties
export const fetchPropertyFields = createAsyncThunk(
  'properties/fetchPropertyFields',
  async (_, { rejectWithValue }) => {
    try {
      const response = await Axios.get('/broker/properties/config', authHeaders());
      return response.data; // On success, return the data
    } catch (error) {
      return rejectWithValue(error.response.data); // On failure, return the error message
    }
  }
);

const initialState = {
  propertyFields: {
    property_type: [],
    transaction_type: [],
    possession: [],
    status: [],
    city: [],
  },
  isLoading: false,
  error: null,
};

const fieldsSlice = createSlice({
  name: 'fields',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchPropertyFields.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchPropertyFields.fulfilled, (state, action) => {
        state.isLoading = false;
        state.propertyFields = action.payload.data; // Set the dropdown data
      })
      .addCase(fetchPropertyFields.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || 'Failed to fetch property fields data';
      });
  },
});

export default fieldsSlice.reducer;
